import { Moment } from "moment";
import Utils from "../utils";
import { SyncModel, SyncDataModel, DataModel } from "./syncModel";

// Requests
export class TermConfirmedSyncModel extends SyncModel {
  public terms_confirmed: SetTermConfirmedModel[];
}

export class SetTermConfirmedModel {
  public id: number;
  public version_ymd: number;
  public version_hms: number;
}

// Responses
export class TermConfirmedDataModel extends DataModel {
  public get DM_Key(): number | string { return this.id + "|" + this.version_ymd + "|" + this.version_hms; }
  public id: number;
  public version_ymd: number;
  public version_hms: number;
  public get term_version(): Moment {
    return Utils.GetMomentFromInt(this.version_ymd, this.version_hms);
  }
  public confirmed_at_ymd: number;
  public confirmed_at_hms: number;
  public get confirmed_at(): Moment {
    return Utils.GetMomentFromInt(this.confirmed_at_ymd, this.confirmed_at_hms);
  }
}

export class TermConfirmedSyncDataModel extends SyncDataModel {
  public terms_confirmed: TermConfirmedDataModel[];
  public get models(): DataModel[] { return this.terms_confirmed; }
  public DeserializeType(): void {
    this._DeserializeType(TermConfirmedDataModel);
  }
}
